module.exports = __webpack_public_path__ + "08d8aea54bdcc3977d719f0dea902d37.png";